module.exports = __webpack_public_path__ + "static/img/prize-3.8ac5043d.png";